module.exports = {
	"textures": [
		{
			"image": "LuckyNumberJackpot",
			"format": "RGBA8888",
			"size": {
				"w": 800,
				"h": 797
			},
			"scale": 1,
			"frames": [
				{
					"filename": "0.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 200,
						"h": 200
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 200,
						"h": 199
					},
					"frame": {
						"x": 0,
						"y": 0,
						"w": 200,
						"h": 199
					}
				},
				{
					"filename": "1.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 200,
						"h": 200
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 200,
						"h": 199
					},
					"frame": {
						"x": 0,
						"y": 199,
						"w": 200,
						"h": 199
					}
				},
				{
					"filename": "2.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 200,
						"h": 200
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 200,
						"h": 200
					},
					"frame": {
						"x": 200,
						"y": 0,
						"w": 200,
						"h": 200
					}
				},
				{
					"filename": "3.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 200,
						"h": 200
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 200,
						"h": 199
					},
					"frame": {
						"x": 200,
						"y": 200,
						"w": 200,
						"h": 199
					}
				},
				{
					"filename": "4.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 200,
						"h": 200
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 200,
						"h": 200
					},
					"frame": {
						"x": 400,
						"y": 0,
						"w": 200,
						"h": 200
					}
				},
				{
					"filename": "5.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 200,
						"h": 200
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 200,
						"h": 200
					},
					"frame": {
						"x": 400,
						"y": 200,
						"w": 200,
						"h": 200
					}
				},
				{
					"filename": "6.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 200,
						"h": 200
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 200,
						"h": 200
					},
					"frame": {
						"x": 0,
						"y": 398,
						"w": 200,
						"h": 200
					}
				},
				{
					"filename": "7.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 200,
						"h": 200
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 200,
						"h": 200
					},
					"frame": {
						"x": 200,
						"y": 399,
						"w": 200,
						"h": 200
					}
				},
				{
					"filename": "8.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 200,
						"h": 200
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 200,
						"h": 199
					},
					"frame": {
						"x": 0,
						"y": 598,
						"w": 200,
						"h": 199
					}
				},
				{
					"filename": "9.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 200,
						"h": 200
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 200,
						"h": 200
					},
					"frame": {
						"x": 400,
						"y": 400,
						"w": 200,
						"h": 200
					}
				},
				{
					"filename": "10.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 200,
						"h": 200
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 200,
						"h": 200
					},
					"frame": {
						"x": 600,
						"y": 0,
						"w": 200,
						"h": 200
					}
				},
				{
					"filename": "11.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 200,
						"h": 200
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 199,
						"h": 198
					},
					"frame": {
						"x": 200,
						"y": 599,
						"w": 199,
						"h": 198
					}
				}
			]
		}
	],
	"meta": {
		"app": "http://free-tex-packer.com",
		"version": "0.6.7"
	}
};